module.exports = __webpack_public_path__ + "static/media/learn_jp1.78dad980.png";